import { format } from "date-fns";
import axiosClient from "../apiClient";
import { DATE_FORMAT } from "../utils/appConstants";
import { AxiosResponse } from "axios";
import { formatQueryArrayParam } from "../utils/utils";

export const CampaignsService = async (
  params: {
    source?: string[];
    start_date?: Date;
    end_date?: Date;
    skip: number;
    limit: number;
    search: string;
    status: string;
    form_id?: number;
    ad_account_id: null | string;
  },
  signal?: AbortSignal
): Promise<AxiosResponse> => {
  try {
    let startDateString;
    let endDateString;
    if (params.start_date && params.end_date) {
      startDateString = format(new Date(params.start_date), DATE_FORMAT);
      endDateString = format(new Date(params.end_date), DATE_FORMAT);
    }

    let queryString = `?skip=${params.skip}&limit=${params.limit}`;

    if (params.source && !params.source.includes("All")) {
      const query = formatQueryArrayParam("provider", params.source);
      queryString = `${queryString}&${query}`;
    }

    if (params.start_date && params.end_date) {
      queryString = `${queryString}&start_date=${startDateString}&end_date=${endDateString}`;
    }
    if (params.search) {
      queryString = `${queryString}&search=${params.search}`;
    }
    if (params.status && !params.status.includes("All")) {
      queryString = `${queryString}&status=${params.status}`;
    }
    if (params.ad_account_id) {
      queryString = `${queryString}&ad_account_id=${
        params.ad_account_id ?? ""
      }`;
    }
    if (params.form_id) {
      queryString = `${queryString}&form_id=${params.form_id}`;
    }

    const response = await axiosClient.get(`/campaigns${queryString}`, {
      signal,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const InsightsService = async (
  params: {
    source?: string[];
    start_date?: Date;
    end_date?: Date;
    page: number;
    limit: number;
    search: string;
    group_by: string;
    form_id?: number;
    ad_account_id: null | string;
    sort_column?: string;
    sort_direction?: string;
  },
  signal?: AbortSignal
): Promise<AxiosResponse> => {
  try {
    let startDateString;
    let endDateString;
    if (params.start_date && params.end_date) {
      startDateString = format(params.start_date, DATE_FORMAT);
      endDateString = format(params.end_date, DATE_FORMAT);
    }

    let queryString = `?page=${params.page}&limit=${params.limit}&group_by=${params.group_by}`;

    if (params.source && !params.source.includes("All")) {
      const query = formatQueryArrayParam("provider", params.source);
      queryString = `${queryString}&${query}`;
    }

    if (params.start_date && params.end_date) {
      queryString = `${queryString}&start_date=${startDateString}&end_date=${endDateString}`;
    }
    if (params.search) {
      queryString = `${queryString}&search=${params.search}`;
    }

    if (params.ad_account_id) {
      queryString = `${queryString}&ad_account_id=${
        params.ad_account_id ?? ""
      }`;
    }
    if (params.form_id) {
      queryString = `${queryString}&form_id=${params.form_id}`;
    }

    if (params.sort_column && params.sort_direction) {
      queryString = `${queryString}&sort_column=${params.sort_column}&sort_direction=${params.sort_direction}`;
    }

    const response = await axiosClient.get(`/insights${queryString}`, {
      signal,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCampaignsDetailService = async (params: {
  campaign_id: string;
}): Promise<AxiosResponse> => {
  const queryString = `?campaign_id=${params.campaign_id}`;

  const response = await axiosClient.get(`/campaigns/details${queryString}`);
  return response;
};

export const AdsAccountsService = async () => {
  try {
    const response = await axiosClient.get("/ads-accounts");
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAdsCopiesByCampaignId = async (params: {
  campaign_id: string;
}): Promise<AxiosResponse> => {
  try {
    const response = await axiosClient.get(
      `campaigns/${params?.campaign_id}/ads`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// export const CampaignsByAdAccountService = async (
//   adAccountId: string | number
// ) => {
//   try {
//     const response = await axiosClient.get(`/campaigns/${adAccountId}/ads`);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };
